import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { observer } from 'mobx-react';

import LeadsTable from '../../../../components/Leads/components/LeadsTable';
import PageContent from '../../../../components/PageContent';
import { LeadsTableType } from '../../../../components/Leads/components/LeadsTable/utils';
import { AllLeadStates, ISDashboardSalesStages } from '../../../../Model/Lead';
import ISDashboardTabs from '../LeadsTableSection/tabs';

const LeadsContacted = ({
  coachesList,
  setSelectedLead,
  setShowQuestionsModal,
  onOnboardingLinkClick,
  onNotesClick,
  leads,
  userId,
  userName,
}) => (
  <PageContent>
    <LeadsTable
      rows={leads}
      selectLead={setSelectedLead}
      setShowQuestionsModal={setShowQuestionsModal}
      onOnboardingLinkClick={onOnboardingLinkClick}
      selectedLeadStates={AllLeadStates}
      selectedSalesStages={ISDashboardSalesStages}
      type={LeadsTableType.IS_LEADS}
      userId={userId}
      userName={userName}
      onNotesClick={onNotesClick}
      coachesList={coachesList}
      activeSalesStageFilter={ISDashboardTabs.LEADS_CONTACTED}
      isDisableStatusChange
    />
  </PageContent>
);

LeadsContacted.propTypes = {
  setSelectedLead: PropTypes.func.isRequired,
  setShowQuestionsModal: PropTypes.func.isRequired,
  onOnboardingLinkClick: PropTypes.func.isRequired,
  onNotesClick: PropTypes.func.isRequired,
  coachesList: PropTypes.object,
  leads: PropTypes.array.isRequired,
  userId: PropTypes.string.isRequired,
  userName: PropTypes.string.isRequired,
};

LeadsContacted.defaultProps = {
  coachesList: {},
};

export default compose(
  observer,
)(LeadsContacted);
